(function () {
  'use strict';

  var mq = window.matchMedia('(hover: hover) and (pointer: fine)');

  function shouldIgnoreClick(target) {
    if (target.closest('.banner__buttons')) return true;
    if (target.closest('.slideshow__controls')) return true;
    if (target.closest('.nav-down')) return true;
    if (target.closest('a')) return true;
    if (target.closest('button')) return true;
    return false;
  }

  function init(root) {
    var slider = root.querySelector('[id^="Slider-"]');
    var slides = slider ? slider.querySelectorAll('[id^="Slide-"]') : [];
    var nextBtn = root.querySelector('button[name="next"]');
    var prevBtn = root.querySelector('button[name="previous"]');
    var cursorEl = root.querySelector('.slideshow-v3-cursor');
    if (!slider || !nextBtn || !prevBtn || !cursorEl) return;
    var touchStartX = 0;
    var touchStartY = 0;
    var touchStartScrollLeft = 0;
    var touchStartPage = 1;
    var swipeThreshold = 40;
    var edgeTolerance = 8;

    function getLastSlidePosition() {
      var lastSlide = slides[slides.length - 1];
      return lastSlide ? lastSlide.offsetLeft : slider.scrollWidth - slider.clientWidth;
    }

    function getCurrentPage() {
      if (typeof root.currentPage === 'number') return root.currentPage;
      if (slides.length < 2) return 1;
      var slideOffset = slides[1].offsetLeft - slides[0].offsetLeft;
      return slideOffset ? Math.round(slider.scrollLeft / slideOffset) + 1 : 1;
    }

    function onPointerMove(e) {
      if (!mq.matches) return;
      if (e.target.closest && e.target.closest('.banner__buttons')) {
        cursorEl.setAttribute('hidden', '');
        root.style.cursor = 'auto';
        return;
      }
      root.style.cursor = 'none';
      cursorEl.removeAttribute('hidden');
      cursorEl.style.left = e.clientX + 'px';
      cursorEl.style.top = e.clientY + 'px';
      var rect = slider.getBoundingClientRect();
      var mid = rect.left + rect.width / 2;
      var pointRight = e.clientX >= mid;
      cursorEl.classList.toggle('slideshow-v3-cursor--right', pointRight);
      cursorEl.classList.toggle('slideshow-v3-cursor--left', !pointRight);
    }

    function onPointerLeave() {
      cursorEl.setAttribute('hidden', '');
      root.style.cursor = '';
    }

    function onClick(e) {
      if (shouldIgnoreClick(e.target)) return;
      var rect = slider.getBoundingClientRect();
      var mid = rect.left + rect.width / 2;
      if (e.clientX < mid) {
        prevBtn.click();
      } else {
        nextBtn.click();
      }
      e.preventDefault();
    }

    function onTouchStart(e) {
      if (!e.touches || e.touches.length !== 1) return;
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
      touchStartScrollLeft = slider.scrollLeft;
      touchStartPage = getCurrentPage();
    }

    function onTouchEnd(e) {
      if (!e.changedTouches || e.changedTouches.length !== 1 || slides.length < 2) return;
      var deltaX = e.changedTouches[0].clientX - touchStartX;
      var deltaY = e.changedTouches[0].clientY - touchStartY;
      var lastSlidePosition = getLastSlidePosition();
      var startedAtFirstSlide = touchStartPage <= 1 || touchStartScrollLeft <= edgeTolerance;
      var startedAtLastSlide = touchStartPage >= slides.length || touchStartScrollLeft >= lastSlidePosition - edgeTolerance;
      var isHorizontalSwipe = Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) >= swipeThreshold;

      if (!isHorizontalSwipe) return;

      if (startedAtLastSlide && deltaX < 0) {
        nextBtn.click();
      } else if (startedAtFirstSlide && deltaX > 0) {
        prevBtn.click();
      }
    }

    root.addEventListener('mousemove', onPointerMove);
    root.addEventListener('mouseleave', onPointerLeave);
    root.addEventListener('click', onClick, true);
    slider.addEventListener('touchstart', onTouchStart, { passive: true });
    slider.addEventListener('touchend', onTouchEnd, { passive: true });
  }

  function initAll() {
    document.querySelectorAll('slideshow-component.slideshow-v3').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
